const fragment = `
  id
  name
  imageUrl  
  lastModifiedLog @include(if: $withLastModification) {
    id
    initialValue
    finalValue
    maker {
      id
      name
      role
    }
  }
  creator @include(if: $withCreator) {
    id
    name
    role
  }
`;

export const listProductTypesQuery = `
  query ListProductTypes(
    $filter: ProductTypeFilterInput
    $withLastModification: Boolean! = false
    $withCreator: Boolean! = false
  ) {
    items: listProductTypes(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getProductTypeQuery = `
  query GetProductType(
    $id: Int!
    $withLastModification: Boolean! = true
    $withCreator: Boolean! = true
  ) {
    item: getProductType(id: $id) {
      ${fragment}
    }
  }
`;

export const createProductTypeQuery = `
  mutation CreateProductType(
    $input: CreateProductTypeInput!
    $image: Upload
    $withLastModification: Boolean! = true
    $withCreator: Boolean! = true
  ) {
    item: createProductType(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateProductTypeQuery = `
  mutation UpdateProductType(
    $input: UpdateProductTypeInput!
    $image: Upload
    $withLastModification: Boolean! = true
    $withCreator: Boolean! = true
  ) {
    item: updateProductType(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteProductTypeQuery = `
  mutation DeleteProductType(
    $id: Int!
    $withLastModification: Boolean! = true
    $withCreator: Boolean! = true
  ) {
    item: deleteProductType(id: $id) {
      ${fragment}
    }
  }
`;
